import Vue from "vue";
import Vuex from "vuex";
import ApiDossierRepository from "@/repositories/ApiDossierRepository";
import ApiUserRepository from "@/repositories/ApiUserRepository";
import cookies from "vue-cookies";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: null,
    dossiers: null,
    loading: {
      display: true,
      message: "Chargement en cours..."
    },
    formLoading: false,
    isAuthenticated: false,
    isAuthNonConnected: false,
    dossier: null
  },

  mutations: {
    setUser(state, newUser) {
      state.user = newUser;
      if (newUser !== null) {
        state.isAuthenticated = true;
        state.isAuthNonConnected = false;
      }
    },
    setNonConnectedUser(state, newUser) {
      state.user = newUser;
      if (newUser !== null) {
        state.isAuthenticated = true;
        state.isAuthNonConnected = true;
      }
    },
    setEcranChargement(state, display) {
      state.loading.display = display;
    },

    setMessageEcranChargement(state, message) {
      state.loading.message = message;
    },
    setDossier(state, dossier) {
      state.dossier = dossier;
    },
    setDossiers(state, dossiers) {
      state.dossiers = dossiers;
    },
    setFormLoading(state, bool) {
      state.formLoading = bool;
    }
  },

  actions: {
    async setNonConnectedUser({ commit }, user) {
      commit("setNonConnectedUser", user);
    },
    async loadUser({ commit }) {
      let newUser = cookies.get("pharmagrement-user");
      if (newUser == null) {
        newUser = await ApiUserRepository.getUser();
      }
      if (Object.keys(newUser).length === 0) {
        newUser = null;
      }
      commit("setUser", newUser);
    },
    async switchUser({ commit }, idUser) {
      const user = await ApiUserRepository.switchUser(idUser);
      commit("setUser", user);
    },
    async unswitchUser({ commit }) {
      const user = await ApiUserRepository.unswitchUser();
      commit("setUser", user);
    },
    setDossier({ commit }, dossier) {
      commit("setDossier", dossier);
    },
    async loadDossiers({ commit }) {
      let dossiers = await ApiDossierRepository.getAllResumesDossier();
      commit("setDossiers", dossiers);
    },
    setFormLoading({ commit }, bool) {
      commit("setFormLoading", bool);
    },
    updateDossier({ commit }, dossier) {
      commit(
        "setDossiers",
        this.state.dossiers.map(d => {
          if (d.id === dossier.id) {
            return dossier;
          }
          return d;
        })
      );
    },
    removeDossier({ commit }, dossier) {
      commit(
        "setDossiers",
        this.state.dossiers.filter(d => d.id !== dossier.id)
      );
    }
  }
});
